import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { dropdown } from "../Animation"
import { StaticQuery, graphql } from "gatsby"

export const DropWrap = styled.div`
  position: absolute;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  padding: 20px;
  z-index: 109;
  background: #0059b2;
  opacity: 1;
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  border: 1px solid rgba(165, 205, 240, 0.6);
  border-radius: 8px;
  box-shadow: 0 15px 45px rgba(0, 128, 255, 0.4);
  animation: ${dropdown} ease 0.5s;
  max-width: 298px;
  min-width: 298px;
  text-align: left;
  & a {
    color: white;
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
    font-family: 'UniNeueBold', sans-serif;
    padding: 5px 0;
    display: block;
    &:hover {
      text-decoration: underline !important;
    }
  }
`
DropWrap.defaultProps = {
  top: "80px",
  left: "0",
  width: "100%",
}
export const Divider = styled.div`
  border-top: 1px solid #317cc6;
  width: 100%;
`
export const Triangle = styled.div`
  position: relative;
  box-sizing: border-box;
  background: #0059b2;
  box-shadow: 0px 25px 65px rgba(165, 205, 240, 0.6);
  & :after {
    content: "";
    position: absolute;
    top: -15px;
    width: 0;
    height: 0;
    left: 20%;
    box-sizing: border-box;
    border: 0.5em solid;
    border-color: transparent transparent rgba(165, 205, 240, 0.6)
      rgba(165, 205, 240, 0.6);
    transform-origin: 0 0;
    transform: rotate(135deg) translateX(-50%);
    box-shadow: -3px 3px 4px -2px rgba(0, 0, 0, 0.1);
  }
`
export const DropBody = styled.div`
  overflow-y: auto;
  max-height: 500px;
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.3);
  }
`

function ElectronicMenu(props) {
  const { width, display, top } = props
  return (
    <StaticQuery
      query={graphql`
        query ElectronicsMenuQuery {
          allContentfulServiceSubRepair(
            filter: {
              service: { serviceName: { eq: "Electronics Repair Services" } }
            }
          ) {
            nodes {
              name
              url
            }
          }
        }
      `}
      render={(data) => {
        return (
          <DropWrap width={width} display={display} top={top} className="dropdown">
            <Triangle bg="white" className="dropdown-arrow"/>
            <DropBody className="dropdown-body">
              {data.allContentfulServiceSubRepair.nodes.map((subMenu, i) => {
                return (
                  <div key={`${subMenu}-${i}`}>
                    <Link to={`/${subMenu.url}`}>{subMenu.name}</Link>
                    <Divider />
                  </div>
                )
              })}
            </DropBody>
          </DropWrap>
        )
      }}
    />
  )
}

export default ElectronicMenu
